'use client';

import type { ReactNode } from 'react';
import type { UnifiedColumn } from './history-table-column-utils';

export function HistoryCellContent({
  column,
  content,
  title,
}: {
  column: UnifiedColumn;
  content: ReactNode;
  title?: string;
}) {
  if (column.id === 'state' || column.id === 'initiator') {
    return <div className="flex justify-center overflow-hidden">{content}</div>;
  }

  if (column.id === 'startTime' || column.id === 'endTime') {
    return <div className="truncate text-center">{content}</div>;
  }

  return (
    <div className="line-clamp-3 break-words text-left text-xs leading-snug" title={title}>
      {content}
    </div>
  );
}
